import { GeneralTable } from "@/shared/components/ui";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { EstadoSolicitudAplicaGremios, obtenerPromocionDePrioridadMasBaja, TABLE_CONSTANTS } from "@/shared";
import { Edit } from "@mui/icons-material";
import { useUiStore } from "@/store/ui";
import { useTableColumnsSolicitudGremios } from "../hooks/useTableColumnsSolicitudGremios";
import { useAuthStore } from "@/store/auth";
import { getAplicaPromocion, useFetchSolicitudGremios, usePutSolicitudGremios, useUpdatePreventa } from "@/shared/actions/erp";
import { SolicitudGremiosComposed } from "@/shared/interfaces";

interface TableSolicitudGremiosProps {
  estado_solicitud?: EstadoSolicitudAplicaGremios
  enableActions?: boolean
}
export default function TableSolicitudGremios({
  estado_solicitud = EstadoSolicitudAplicaGremios.EN_ESPERA,
  enableActions = true
}: TableSolicitudGremiosProps) {

  ///* Hooks
  const {
    columnsGremios
  } = useTableColumnsSolicitudGremios({
    estado_solicitud
  });

  const {
    pagination,
    setPagination,
    vendedor,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } =
    useTableServerSideFiltering();

  const { isLoading, data: solicitudGremios, isRefetching } =
    useFetchSolicitudGremios({
      page: pageIndex + 1,
      estado_solicitud: estado_solicitud,
      page_size: pageSize,
      user_create: vendedor,
      ...filterObject,
      filterByState: false
    });

  const {
    mutateAsync: putSolicitudGremios
  } = usePutSolicitudGremios({})
  const {
    mutateAsync: putPreventa
  } = useUpdatePreventa({})

  const setConfirmDialog = useUiStore(s => s.setConfirmDialog)
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const username = useAuthStore(s => s.user)?.username

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<SolicitudGremiosComposed>
            columns={columnsGremios}
            data={solicitudGremios?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}

            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={solicitudGremios?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            enableEditing={enableActions}
            showCustomActionBtnSpace={enableActions}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  <Grid item >
                    <Tooltip title={'Editar'} placement="top">
                      <IconButton
                        onClick={() => {
                          setConfirmDialogIsOpen(true);

                          setConfirmDialog({
                            isOpen: true,
                            title: 'Aplicar Promoción Gremios',
                            subtitle: `Se solicitó aplicar la PROMOCIÓN GREMIOS para el cliente ${value?.prospecto_data?.razon_social}. ¿Desea aplicar la promoción?`,
                            confirmTextBtn: 'Aprobar',
                            cancelTextBtn: 'Cerrar',
                            onClose() {
                              setConfirmDialogIsOpen(false);
                            },

                            async onReject() {
                              const respPromocion = await getAplicaPromocion({
                                planes: value?.preventa_data?.plan,
                              });
                              const prom = obtenerPromocionDePrioridadMasBaja(respPromocion);
                              await putPreventa({
                                id: value.preventa_data?.id_preventa!,
                                data: {
                                  promociones:[prom!.id_promocion!],
                                }
                              })
                              await putSolicitudGremios({
                                id: value.id_solicitud_aplica_gremios,
                                data: {
                                  estado_solicitud: EstadoSolicitudAplicaGremios.RECHAZADO,
                                  user_aprueba: username
                                }
                              })

                              setConfirmDialogIsOpen(false);
                            },
                            async onConfirm() {
                              await putSolicitudGremios({
                                id: value.id_solicitud_aplica_gremios,
                                data: {
                                  estado_solicitud: EstadoSolicitudAplicaGremios.APROBADO,
                                  user_aprueba: username
                                }
                              })
                              setConfirmDialogIsOpen(false);
                            }
                          });
                        }
                        }
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              )
            }}

          />
        </Grid>
      </Grid>



    </>
  );
}